const COLORS = {
  primary: { border: "border-[#144366]", bg: "bg-[#144366]", btn: "bg-green-100 text-green-700" },
  danger: { border: "border-red-600", bg: "bg-red-600", btn: "bg-red-100 text-red-700" },
  info: { border: "border-blue-900", bg: "bg-blue-900", btn: "bg-yellow-100 text-yellow-700" },
};

export const employee = {
  ACTIVE_COMPANY_ID : 1,
  STATUS : {
    1 : 'Lead',
    2 : 'Rejected',
    3 : 'Active',
    4 : 'Inactive'
  },
  BRANCH:{
    CHENNAI:6,
    COIMBATORE:2
  },
  AUTH_REQUEST_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
  },
  ROLES: {
    ADMIN: 1,
    ACCOUNTS_MANAGER: 3,
    CUSTOMER_SALES: 21,
    CUSTOMER_SALES_MANAGER: 22,
    HR_MANAGER: 19

  },
  ATTENDANCE_DATE_FORMAT: {
    DATECELLFORMAT: "YYYY/MM/DD",
    HEADERFORMAT: "MMM-YYYY",
  },
  ATTENDANCE_MARKER: {
    ALREADY_PRESENT_STATUS_NAME: "Present",
    IS_LEAVE_STATUS_NAME: "Leave",
  },
  GROW_LANDING_PAGES: {
    CUSTOMER_SALES: "CustomerSales",
    OPERATIONS: 'Operations'
  },
  LANDING_PAGE_ROUTES: {
    OPERATIONS: "/indent",
    CustomerSupport: "/employee/customer_support",
    CustomerSales: "/employee/customer_sales",
    organization: "/employee/organization",
    Billing: "/employee/billing/approvals",
    Sales: "/employee/partner_sales"
   },
  ATTENDANCE: {
    PRESENT: 1,
    ABSENT: 2,
    LEAVE: 3,
    HOLIDAY: 4,
  },
  LEAVE_YEAR: [
    { id: 1, year: 2021 },
    { id: 2, year: 2022 },
    { id: 3, year: 2023 },
    { id: 4, year: 2024 },
    { id: 5, year: 2025 },
    { id: 6, year: 2026 },
    { id: 7, year: 2027 },
    { id: 8, year: 2028 },
    { id: 9, year: 2029 },
    { id: 10, year: 2030 },
    { id: 11, year: 2031 },
    { id: 12, year: 2032 },
    { id: 13, year: 2033 },
    { id: 14, year: 2034 },
    { id: 15, year: 2035 },
    { id: 16, year: 2036 },
    { id: 17, year: 2037 },
    { id: 18, year: 2038 },
    { id: 19, year: 2039 },
    { id: 20, year: 2040 },
  ],
  LEAVE_STATUS: {
    APPROVED: 1,
    CANCELLED: 2,
  },
  LEAVE_TYPE: [
    { id: 1, name: "Consolidated Leave" },
    { id: 2, name: "Optional Leave" },
    { id: 3, name: "Sick Leave" },
    { id: 4, name: "LOP" },
  ],
  OPS_FUNCTION_REGIONS: {
    SOUTH: [65,61,25,14,12,11,4]
  },
  CLAIM: {
    EXPENSES_CLAIM_TYPE: "Expense Claim",
    EXPENSES_AVATAR: "E",
    ADVANCE_AVATAR: "A",
    MANAGER_APPROVED_STATUS_ID : 4,
    CLAIM_REJECTED_STATUS_ID : 2,
    CLAIM_CANCELLED_STATUS_ID : 5,
    CLAIM_PENDING_STATUS_ID : 3,
    CLAIMS_CLOSED_STATUS_IDS: [1, 2, 5],
    PAYMENT_UNPAID_STATUS_ID : 2,
    CLAIM_PENDING_OR_MANAGER_APPROVED : [3,4],
    CLOSED_CLAIM_STATUS : ["Approved", "Cancelled", "Rejected", "Paid"],
    CLAIM_LIST_STATUS: [
      { id: 1, name: "Paid", color: "green" },
      { id: 2, name: "Rejected", color: "red" },
      { id: 3, name: "Pending", color: "yellow" },
      { id: 4, name: "Approved", color: "green" },
      { id: 5, name: "Cancelled", color: "red" },
    ],
    STATUS: {
      OPEN: [3, 4],
      CLOSED: [1, 2, 5],
      ALL: [1, 2, 3, 4, 5],
    },
    CATEGORY : {
      expenses: [
        { id: 1, name: "Bill Submission" },
        { id: 2, name: "Client meet" },
        { id: 3, name: "Admin work" },
        { id: 4, name: "Food expense" },
        { id: 5, name: "Training reimbursement" },
        { id: 6, name: "Truck struck" },
      ],
      advance: [
        { id: 7, name: "Salary advance" },
        { id: 8, name: "Travel advance" }
      ],
    },
    CATEGORY_TYPE : {
      expenses: 1,
      advance : 2
    },
    CLAIM_STATUS: [
      { id: 1, name: "Approved", ...COLORS.primary },
      { id: 2, name: "Rejected", ...COLORS.danger },
      { id: 3, name: "Pending", ...COLORS.info },
      { id: 4, name: "Manager Approved", ...COLORS.info },
      { id: 5, name: "Cancelled", ...COLORS.danger },
    ],
  },
  HOLIDAY : {
    TYPE : {
      OPTIONAL : 1,
      HOLIDAY : 2
    } as const
  },
  RESIGNATION : {
    ID : 3,
    MANAGER_APPROVE_ID : 4,
    REJECT_STATUS_ID : 2,
    DISABLE_STATUS_ID : [2,4],
    STATUS : {
      1: "text-green-600",
      2: "text-red-600",
      3: "text-yellow-600",
      4: "text-green-600",
      5: "text-red-600"
    },
    REASON : [
      {id : 1 , name : "Personal Reason"},
      {id : 2 , name : "Health Related Aspects"},
      {id : 3 , name : "Termination"},
      {id : 4 , name: "Better Career Prospect"},
      {id : 5 , name : "Dissatisfaction with the Job"}

    ]
  },
  EMPLOYEE_FUNCTION_GROUP: {
    OPERATIONS: 3
  },
  EMPLOYEE_FUNCTION: {
    FINANCE: 3
  },
};
